<template>
  <section>
    <gs-header title="Sửa tỉnh thành"
      :breadcrumbs="[
        {title: 'Quản lý tỉnh thành', route: {name: 'city'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localCity" :rules="rules" ref="createCityForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitCity('createCityForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localCity.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Tên viết tắt" prop="short_name">
              <el-input v-model="localCity.short_name" placeholder="Tên viết tắt"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Mã bưu chính " prop="code">
              <el-input v-model="localCity.code" placeholder="Mã bưu chính"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="Chọn vùng miền" prop="region_id">
              <el-select v-model="localCity.region_id" filterable placeholder="Chọn vùng miền" class="width-100">
                <el-option
                  label="Chọn vùng miền"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.name"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Lấy hàng " prop="allow">
              <el-checkbox v-model="localCity.allow">Lấy hàng</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-for="(carrier, index) in listCarriers" :key="index">
            <el-form-item :label="carrier.name" :key="localCity[carrier.key]">
              <el-input v-model="localCity[carrier.key]" :placeholder="carrier.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Danh sách vùng miền">
              <el-select
                class="width-100"
                v-model="localCity.regions"
                multiple
                filterable
                placeholder="Danh sách vùng miền"
                >
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.name"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Các loại tên" prop="map_name">
              <el-select
                v-model="mapNames"
                multiple
                filterable
                allow-create
                default-first-option
                :reserve-keyword="false"
                placeholder="Chọn các loại tên cho tỉnh thành phố"
                style="width: 100%"
                no-data-text="Không có dữ liệu"
                @change="handleChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { editCity, getCity } from 'src/api/city'
import { head, findIndex, forEach } from 'lodash'
import mixins from './mixins'
export default {

  name: 'EditCity',
  mixins: [mixins],
  data () {
    return {}
  },
  methods: {
    validateBeforeSubmitCity () {
      this.submitting = true
      this.toggleLoadding()
      this.localCity.map_names = this.mapNames
      this.$refs.createCityForm.validate(valid => {
        if (valid) {
          this.changedData = false
          editCity(this.$route.params.id, this.localCity).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa tỉnh thành thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'city'}, 'cities')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    },
    selectRegion (region) {
      if (findIndex(this.localCity.regions, {id: region.id}) < 0) {
        this.localCity.regions.push(region.id)
      }
    }
  },
  mounted () {
    getCity({id: this.$route.params.id, params: {include: 'regions'}}).then(response => {
      switch (response.code) {
        case 200:
          this.localCity.name = response.data.name
          this.localCity.short_name = response.data.short_name
          this.localCity.region_id = response.data.region_id
          this.localCity.code = response.data.code
          this.localCity.allow = !!response.data.allow
          this.mapNames = response.data && response.data.map_names ? response.data.map_names : []
          this.options = this.mapNames.map((value) => ({
            value,
            label: value,
          }))
          forEach(this.listCarriers, (carrier) => {
            this.localCity[carrier.key] = response.data[carrier.key]
          })
          if (response.data.regions.data.length) {
            forEach(response.data.regions.data, (region) => {
              this.selectRegion(region)
            })
          }
          setTimeout(() => {
            this.watching = true
          }, 100)
          break
        case 404:
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Vùng miền không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
          this.$route.push({name: 'city'})
          break
        default:
      }
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// EditCity.vue?2fdee9a0